export default __webpack_public_path__ + "static/media/bulb-blue.9f3ec768.svg";